export enum DeleteDialogResult {
    DOOD,
    UNSELLABLE
}
